import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';
import { selectors as rootSelectors } from '../../root';

import Table from '../components/table/main';
import createThreadForm from '../components/create-form/main';
import Filters from '../../shared/filters/main';
import Search from '../../shared/search/main';
import Calendar from '../../shared/calendar/main';
import FilterStatuses from '../components/quick-filters/statuses/main';
import TableViewSwitch from  '../components/table-view-switch';
import SwitchControlMulti from '../../shared/switch-control/multi/main';
import CloseForm from '../components/close-form/main';

const CreateThreadsForm = createThreadForm('threadsCreateThreadForm');

const Main = renderViewsState(
	props =>
		<Animate>
			{ props.closeFormShouldShowStatus && (
				<CloseForm
					title={props.intl('Close thread  ID%s', props.closeFormCurrentThreadId)}
					{...props}
					validate={props.closeFormValidate}
					enableReinitialize={true}
					initialValues={props.closeFormInitialValues}
				/>
			) }
			<div className="container__content threads-list">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">
							{props.intl('List of threads')}
						</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="threads-list__filter-position clearfix">
						<Filters {...props} {...props.filters} />
					</div>

					<div className="ui-control-bar">
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<TableViewSwitch {...props} />
							</div>
						</div>
						<div className="ui-control-bar__item modify-item---search">
							<div className="ui-control-bar__item-position">
								<Search
									form="threadsSearchForm"
									action={props.search}
									{...props}
									autoFocus={true}
									initialValues={props.searchData} />
							</div>
						</div>

						<div className="ui-control-bar__item modify-item---calendar">
							<div className="ui-control-bar__item-position">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
						</div>

						<div className="ui-control-bar__item modify-item---filter">
							<div className="ui-control-bar__item-position">
								<FilterStatuses {...props} />
							</div>
						</div>

						<div className="ui-control-bar__item modify-item---filter">
							<div className="ui-control-bar__item-position">
								<SwitchControlMulti
									transformToDropdown={true}
									activateBreakpoint={1665}
									intl={props.intl}
									filters={props.switchControlMultiItems}
									choose={filterValue => {
										props.switchControlMultiChooseFilter(filterValue);
										props.apply();
									}}
								/>
							</div>
						</div>

						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								{props.can('create') &&
								<button
									onClick={() => props.toggleCreateThreadForm()}
									className="ui-btn ui-btn-primary ui-btn-sign__plus"
								>
									{props.intl('Create thread')}
								</button>}
								<button className="ui-btn ui-btn-primary apply" type="submit" onClick={props.apply}>
									{props.intl('Apply')}
								</button>
								<button className="ui-btn ui-btn-secondary ui-icon-clear" onClick={props.clear} />
							</div>
						</div>
					</div>

					<Table
						{...props}
						isIndexing
					/>
					<CreateThreadsForm {...props} destroyOnUnmount={false} initialValues={props.createThreadFormInitialValues} />
				</div>
			</div>
		</Animate>,
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		filters: selectors.getFilters(state),
		searchData: selectors.getSearchData(state),
		calendar: selectors.getCalendar(state),
		pagination: selectors.getPagination(state),
		statuses: selectors.getThreadStatuses(state),
		priorities: selectors.getPrioritiesList(state),
		shouldShowCreateThreadForm: selectors.getShouldShowCreateThreadFormStatus(state),
		progressBar: selectors.getProgressBar(state),
		attachmentsInfo: selectors.getAttachmentsInfo(state),
		createThreadFormInitialValues: selectors.getCreateThreadFormInitialValues(state),
		createThreadFormDisabledFields: selectors.getCreateThreadFormDisabledFields(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		statusesFilters: selectors.getStatusesFilters(state),
		switchControlMultiItems: selectors.getSwitchControlMultiItems(state),
		error: selectors.getError(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		closeFormInitialValues: selectors.getCloseFormInitialValues(state),
		closeFormShouldShowStatus: selectors.getCloseFormShouldShowStatus(state),
		closeFormValidate: selectors.getCloseFormValidate(state),
		closeFormCurrentThreadId: selectors.getCloseFormCurrentThreadId(state),
		requestQueryString: selectors.getRequestQueryString(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/list/main.js